import React from "react";
import { motion } from "motion/react";

interface SectionEmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description: string | React.ReactNode;
  actionButton?: React.ReactNode;
}

export default function SectionEmptyState({
  icon,
  title,
  description,
  actionButton,
}: SectionEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      {icon && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0 }}
          className="bg-accent/20 rounded-md p-4 w-20 h-20 flex items-center justify-center border-2 border-accent mb-8"
        >
          {icon}
        </motion.div>
      )}
      {/* Explanation */}
      <div className="text-center max-w-lg mb-8">
        <motion.h3
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="text-xl font-semibold text-primary mb-3"
        >
          {title}
        </motion.h3>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
          className="text-secondary leading-relaxed"
        >
          {description}
        </motion.div>
      </div>

      {/* Call to Action */}
      {actionButton && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.3 }}
        >
          {actionButton}
        </motion.div>
      )}
    </div>
  );
}
